<template>
    <div id="content">
        <!--
        <Menu page="about"></Menu>
        -->
        <div class="element">
            <p>
                This is the digital archive of Julian Mader and Max Prediger.
                Our design studio, JMMP, focuses on typography, type design and
                visual systems. We translate content into analogue and digital
                formats across two- and three-dimensional spaces. The people we
                work with are active in the fields of art, culture and
                knowledge.
            </p>
            <br />
            <p>
                In addition to individual commissions, we provide ongoing art
                direction for Montez Press (London), Montez Press Radio (New
                York City), Theater Freiburg (Freiburg), Jahn und Jahn
                (Munich/Lisbon), Kunsthalle Münster (Münster) and Kunstverein
                Harburger Bahnhof (Hamburg).
            </p>
            <br />
            <p>
                In 2025, Jakob Wilke joined JMMP as a designer. Alongside our
                core team, we collaborate with a network of designers,
                developers, lithographers and photographers.
            </p>
            <br />
            <p>
                Our work has received the Type Directors Club New York
                Certificate of Typographic Excellence and has also been
                recognised by 100 Beste Plakate (Germany / Austria /
                Switzerland). In 2022 and 2026, the Stiftung Buchkunst selected
                one of our books as among the Most Beautiful German Books, while
                another was shortlisted in 2022.
            </p>
            <br />
            <p>
                Over the past decade, we have held teaching positions and led
                workshops at HAW Hamburg and HFBK Hamburg. In 2024 and 2025, we
                served as visiting professors, leading Professor Ingo
                Offermanns' Graphic Design Class (Klasse Grafik) at HFBK
                Hamburg.
            </p>
            <br />
            <p>Contact</p>

            <br />
            <p>JMMP – Julian Mader Max Prediger GbR</p>
            <p>Schützenstraße 39, 22761 Hamburg, Germany</p>
            <br />

            <p>For general inquiries please contact: jmmp@jmmp.eu</p>
            <p>
                We currently have no internship openings and cannot respond to
                applications.
            </p>
            <br />

            <p>
                <a target="_blank" href="https://www.instagram.com/jmmp.studio/"
                    >Follow us on Instagram</a
                >
            </p>
            <p>
                <a target="_blank" href="https://goo.gl/maps/UWVqQH2cQuZBXdFR7"
                    >Find us on Google Maps</a
                >
            </p>
            <br />

            <p>Website development: Dominic Osterried</p>
            <p>Studio Photography: Edward Greiner and JMMP</p>
            <br />

            <p
                id="disclaimer"
                @click="disclaimer = true"
                :class="{ active: disclaimer }"
            >
                Disclaimer
            </p>

            <div v-if="disclaimer">
                <br />
                <p>
                    Haftung für Inhalte: Die Inhalte unserer Seiten wurden mit
                    größter Sorgfalt erstellt. Für die Richtigkeit,
                    Vollständigkeit und Aktualität der Inhalte können wir jedoch
                    keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß
                    § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                    allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG
                    sind wir als Diensteanbieter jedoch nicht verpﬂ ichtet,
                    übermittelte oder gespeicherte fremde Informationen zu
                    überwachen oder nach Umständen zu forschen, die auf eine
                    rechtswidrige Tätigkeit hinweisen. Verpﬂ ichtungen zur
                    Entfernung oder Sperrung der Nutzung von Informationen nach
                    den allgemeinen Gesetzen bleiben hiervon unberührt. Eine
                    diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                    Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                    Bekanntwerden von entsprechenden Rechtsverletzungen werden
                    wir diese Inhalte umgehend entfernen.
                </p>
                <p>
                    Haftung für Links: Unser Angebot enthält Links zu externen
                    Webseiten Dritter, auf deren Inhalte wir keinen Einﬂ uss
                    haben. Deshalb können wir für diese fremden Inhalte auch
                    keine Gewähr übernehmen. Für die Inhalte der verlinkten
                    Seiten ist stets der jeweilige Anbieter oder Betreiber der
                    Seiten verantwortlich. Die verlinkten Seiten wurden zum
                    Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                    überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                    Verlinkung nicht erkennbar. Eine permanente inhaltliche
                    Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                    Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
                    Bekanntwerden von Rechtsverletzungen werden wir derartige
                    Links umgehend entfernen.
                </p>
                <p>
                    Statistische Auswertung mit Piwik: Diese Website benutzt
                    Piwik, eine Open-Source-Software zur statistischen
                    Auswertung der Besucherzugriffe. Piwik verwendet sog.
                    “Cookies”, Textdateien, die auf Ihrem Computer gespeichert
                    werden und die eine Analyse der Benutzung der Website durch
                    Sie ermöglichen. Die durch den Cookie erzeugten
                    Informationen über Ihre Benutzung dieses Internetangebotes
                    werden auf dem Server des Anbieters in Deutschland
                    gespeichert. Die IP-Adresse wird sofort nach der
                    Verarbeitung und vor deren Speicherung anonymisiert. Sie
                    können die Installation der Cookies durch eine entsprechende
                    Einstellung Ihrer Browser Software verhindern; wir weisen
                    Sie jedoch darauf hin, dass Sie in diesem Fall
                    gegebenenfalls nicht sämtliche Funktionen dieser Website
                    vollumfänglich nutzen können.
                </p>
                <p>
                    Urheberrecht: Die durch die Seitenbetreiber erstellten
                    Inhalte und Werke auf diesen Seiten unterliegen dem
                    deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                    Verbreitung und jede Art der Verwertung außerhalb der
                    Grenzen des Urheberrechtes bedürfen der schriftlichen
                    Zustimmung des jeweiligen Autors bzw. des Erstellers.
                    Downloads und Kopien dieser Seite sind nur für den privaten,
                    nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte
                    auf dieser Seite nicht von uns erstellt wurden, werden die
                    Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                    Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf
                    eine Urheberrechtsverletzung aufmerksam werden, bitten wir
                    um einen entsprechenden Hinweis. Bei Bekanntwerden von
                    Rechtsverletzungen werden wir derartige Inhalte umgehend
                    entfernen.
                </p>
                <p>
                    Datenschutz: Die Nutzung unserer Webseite ist in der Regel
                    ohne Angabe personenbezogener Daten möglich. Die Betreiber
                    der Seiten behalten sich ausdrücklich rechtliche Schritte im
                    Falle der unverlangten Zusendung von Werbeinformationen,
                    etwa durch Spam-Mails, vor.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Menu from "@/components/Menu";
import { store } from "@/centralStore";
export default {
    name: "NewStudio",
    components: {
        Menu
    },
    data() {
        return {
            store: store.state,
            imprint: false,
            disclaimer: false
        };
    },
    methods: {
        handleNewsletterClick() {
            console.log("newsletter");
        },
        handleImprintClick() {
            this.imprint = true;
        }
    },
    activated() {
        this.store.inverted = false;
        this.store.lastAbout = "studio-dev";
        document.body.classList.add("index");
    },
    mounted() {
        this.store.inverted = false;
        document.body.classList.add("index");
    },
    beforeRouteLeave(to, from, next) {
        document.body.classList.remove("index");
        next();
    },
    beforeRouteUpdate(to, from, next) {
        document.body.classList.remove("index");
        next();
    }
};
</script>

<style scoped>
#content {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    height: -webkit-fill-available;
    overflow: auto;
    background-color: black;
    display: flex;
    justify-content: center;
}

p {
    margin: 0;
}

#disclaimer {
    color: #969696;
    cursor: pointer;
    transition: color 0.2s;
}

#disclaimer.active,
#disclaimer:hover {
    color: white;
}

.element {
    margin: 0rem 1rem 0;
    position: relative;
    top: 9.6rem;
    padding-bottom: 1rem;
    text-align: center;
}

@media screen and (min-width: 768px) {
    .element {
        top: 3.65rem;
        margin: 0.5rem 1rem 0.5rem 1rem;
        max-width: 46rem;
    }
}

a {
    color: #969696;
    text-decoration: none;
    transition: color 0.2s;
}

@media screen and (min-width: 768px) {
    a:hover {
        color: white;
    }
}

a:nth-child(2) {
    margin: 0 1rem;
}
</style>
